import PropTypes from 'prop-types';
import React from 'react';

import { Button } from 'common-src/components/base';
import { Colors, ColorsNew } from 'common-src/styles';

import { FormButtons } from 'src/components/buttons';

import CaregiverInlineForm from './CaregiverInlineForm';
import styles from './Caregivers.module.scss';

const CaregiverCard = ({
  caregiver,
  data,
  errors,
  isEditMode,
  isGuide,
  isLoading,
  disableEdit,
  showActions,
  isDeleting,
  onChange,
  onEdit,
  onCancel,
  onSubmit,
  onMarkInactive,
}) => (
  <div className={styles.caregiverBlock}>
    <div className={styles.caregiverHeader}>
      <p className={[styles.caregiverTitle, 'font-w-600', 'font-s-16'].join(' ')}>
        {caregiver.firstName} {caregiver.lastName}
      </p>
      {caregiver.isPrimary && <span className={styles.primaryBadge}>Primary caregiver</span>}
    </div>
    <CaregiverInlineForm
      data={data}
      errors={errors}
      isEditMode={isEditMode}
      isGuide={isGuide}
      onChange={onChange}
    />
    {showActions && (
      <div className={styles.actionsRow}>
        <FormButtons
          isLoading={isLoading}
          isEditMode={isEditMode}
          isButtonEnabled
          buttonLabel="caregiver"
          editHandler={onEdit}
          submitHandler={onSubmit}
          cancelHandler={onCancel}
          disabled={disableEdit || isDeleting}
          isSectionForm
          sectionName={`caregiver-${caregiver.id}`}
        />
        {!isEditMode && (
          <Button
            id={`mark-inactive-caregiver-${caregiver.id}`}
            classNames={[styles.secondaryActionButton, 'gap-8']}
            text="Mark as inactive"
            onClick={onMarkInactive}
            isLoading={isDeleting}
            disabled={disableEdit || isDeleting}
            backgroundColor={Colors.white}
            borderColor="transparent"
            textColor={ColorsNew.mediumDarkRed}
          />
        )}
      </div>
    )}
  </div>
);

CaregiverCard.propTypes = {
  caregiver: PropTypes.shape({
    id: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    isPrimary: PropTypes.bool,
  }).isRequired,
  data: PropTypes.shape({}).isRequired,
  errors: PropTypes.shape({}),
  isEditMode: PropTypes.bool,
  isGuide: PropTypes.bool,
  isLoading: PropTypes.bool,
  disableEdit: PropTypes.bool,
  showActions: PropTypes.bool,
  isDeleting: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  onEdit: PropTypes.func,
  onCancel: PropTypes.func,
  onSubmit: PropTypes.func,
  onMarkInactive: PropTypes.func,
};

CaregiverCard.defaultProps = {
  errors: {},
  isEditMode: false,
  isGuide: false,
  isLoading: false,
  disableEdit: false,
  showActions: true,
  isDeleting: false,
  onEdit: () => {},
  onCancel: () => {},
  onSubmit: () => {},
  onMarkInactive: () => {},
};

export default CaregiverCard;
